// Custom API endpoint names that don't require auth headers and shouldn't trigger the
// refresh-and-retry flow on 401. Single source of truth shared by auth.interceptor.ts
// and error.interceptor.ts — previously duplicated as two separately maintained arrays.
export const PUBLIC_ENDPOINT_NAMES = ['login', 'refresh-token'];

// Matches on the trailing bare endpoint name ApiService.callCustomApi() builds the URL
// with (see api.service.ts) — robust regardless of what ADMIN_PATH/CUSTOM_API_PATH
// happen to be set to per environment.
export function isPublicEndpoint(url: string): boolean {
  return PUBLIC_ENDPOINT_NAMES.some((name) => url.endsWith(`/${name}`));
}
